import type { ReactNode } from 'react'

/** A Material surface: `<section class="card">` with an icon heading. */
export function Card({ icon, title, children }: { icon: string; title: string; children: ReactNode }) {
  return (
    <section className="card">
      <h2 data-icon={icon}>{title}</h2>
      {children}
    </section>
  )
}
